export const MembersTable = {
  state: {
    memberRoleBeingEdited: null,
    successMessage: null,
    errorMessage: null,
    projectMembers: [
    ],
    toUpdate: null,
  },
  TableHeader: {
    extends: 'Grid',
    columns: '2.2em 1fr 2fr 1fr 1fr',
    padding: 'A1',
    borderBottom: '1px solid --color-line',
    fontWeight: 'bold',
    background: 'background-alt',
    AvatarHeader: {
      text: '',
    },
    NameHeader: {
      text: 'Name',
    },
    EmailHeader: {
      text: 'Email',
    },
    RoleHeader: {
      text: 'Role',
    },
    ActionsHeader: {
      show: (el) => el.isAdmin(),
      text: 'Actions',
    },
  },
  TableBody: {
    childProps: {
      Avatar: {
        boxSize: 'B',
        text: '{{name}}',
      },
      NameCell: {
        text: '{{name}}',
      },
      EmailCell: {
        text: '{{email}}',
      },
      RoleCell: {
        HiddenElement: {
          show: false,
          tag: 'div',
          display: 'none',
          text: '',
        },
        RoleSelectField: {
          show: (el, s) => s.parent.memberRoleBeingEdited === s.id,
          extends: 'SelectField',
          padding: '0',
          round: 'C1',
          position: 'relative',
          Select: {
            name: 'user',
            id: 'user',
            onChange: (ev, el, s) => {
                ev.preventDefault()
                ev.stopImmediatePropagation()
                s.parent.update({
                  toUpdate: {
                    id: s.id,
                    newRole: ev.target.value
                  }
                })
              },
            childrenAs: 'props',
            children: () => [{
                  value: 'owner',
                  text: 'Owner'
                },
                {
                  value: 'admin',
                  text: 'Admin'
                },
                {
                  value: 'editor',
                  text: 'Editor'
                },
                {
                  value: 'guest',
                  text: 'Guest'
                }
              ],
            childProps: {
              tag: 'option',
              attr: {
                disabled: (el) => !el.isAdmin(),
                selected: (el, s) => s.role === el.value,
              },
            },
          },
        },
        CurrentRole: {
          show: (el, s) => s.parent.memberRoleBeingEdited !== s.id,
          text: '{{role}}',
        },
      },
      ActionsCell: {
        flow: 'x',
        childExtends: 'IconButton',
        show: (el) => el.isAdmin(),
        flow: 'x',
        gap: 'A1',
        EditButton: {
          show: (el, s) => el.isAdmin(),
          background: 'transparent',
          color: 'gray8',
          ':hover': {
            background: 'gray4',
            color: 'white',
          },
          icon: 'edit',
          onClick: (ev, el, s) => {
              s.parent.update({
                memberRoleBeingEdited: s.id,
                toUpdate: null
              })
            },
        },
        ConfirmUpdateRoleButton: {
          show: (el, s) => s.parent.memberRoleBeingEdited === s.id,
          background: 'transparent',
          color: 'gray8',
          icon: 'check',
          ':hover': {
            background: 'gray4',
            color: 'white',
          },
          onClick: async (ev, el, s) => {
              ev.preventDefault()
              ev.stopImmediatePropagation()
              if (!s.parent.toUpdate) {
                return
              }
              try {
                const {
                  id: memberId,
                  newRole
                } = s.parent.toUpdate

                if (newRole) {
                  // Call API to update member role
                  await el.sdk.updateMemberRole(
                    s.root.projectId,
                    memberId,
                    newRole
                  )

                  s.parent.update({
                    memberRoleBeingEdited: null,
                    toUpdate: null,
                    successMessage: 'Member role updated successfully!'
                  })

                  // Refresh the table after a short delay
                  setTimeout(async () => {
                    const result = await el.sdk.getProjectMembers(
                      s.root.projectId
                    )
                    s.parent.replace({
                      projectMembers: result.map((r) => ({
                        ...r,
                        id: r.user.id,
                        email: r.user.email,
                        name: r.user.name || r.user.email,
                        role: r.role
                      })) || []
                    })
                  }, 500)
                }
              } catch (error) {
                s.parent.update({
                  errorMessage: `Error: ${
                  error.message || 'Failed to update member role'
                }`,
                  memberRoleBeingEdited: null,
                  toUpdate: null
                })
              }
            },
        },
        CrossmarkButton: {
          show: (el, s) => s.parent.memberRoleBeingEdited === s.id,
          background: 'transparent',
          color: 'gray8',
          ':hover': {
            background: 'gray4',
            color: 'white',
          },
          icon: 'crossmark',
          onClick: (ev, el, s) => {
              s.parent.update({
                memberRoleBeingEdited: null,
                toUpdate: null
              })
            },
        },
        TrashButton: {
          show: (el, s) =>
              s.role !== 'owner' && ['owner', 'admin'].includes(s.root.projectRole),
          background: 'transparent',
          color: 'gray8',
          ':hover': {
            background: 'gray4',
            color: 'white',
          },
          icon: 'trash',
          onClick: async (ev, el, s) => {
              const memberId = s.id
              ev.preventDefault()
              ev.stopImmediatePropagation()

              const memberName = s.name

              const res = window.confirm(
                `Do you really want to remove ${memberName} from this project?`
              )

              if (res) {
                try {
                  await el.sdk.removeMember(
                    el.getRootState('projectId'),
                    memberId
                  )
                  s.parent.update({
                    successMessage: `${memberName} has been removed from the project.`
                  })
                } catch (err) {
                  s.parent.update({
                    errorMessage: `Error: ${
                    err.message || 'Failed to remove member'
                  }`
                  })
                }
              }
            },
        },
      },
      columns: '2.2em 1fr 2fr 1fr 1fr',
      width: '100%',
      align: 'center center',
      padding: 'A1',
      borderBottom: '1px solid var(--color-border-light)',
      ':hover': {
        background: 'var(--color-background-hover)',
      },
    },
    flow: 'y',
    width: '100%',
    childExtends: 'Grid',
    childrenAs: 'state',
    children: ({
        state
      }) => state.projectMembers,
  },
  EmptyMessage: {
    show: (el, s) => !s.projectMembers || s.projectMembers.length === 0,
    text: 'No team members found.',
    padding: 'B1',
    textAlign: 'center',
    opacity: '0.7',
  },
  flow: 'y',
  width: '100%',
  margin: 'B1 0',
  overflow: 'hidden',
  onRender: async (el, s) => {
      const result = await el.sdk.getProjectMembers(el.getRootState('projectId'))
      s.update({
        projectMembers: result.map((r) => ({
          ...r,
          id: r.id,
          email: r.user.email,
          name: r.user.name || r.user.email,
          role: r.role
        })) || []
      })
    },
  onStateUpdate: (changes, el) => {
      if (changes.successMessage) {
        el.call('openNotification', {
          title: 'Success message',
          message: changes.successMessage,
          type: 'success'
        })
      }
      if (changes.errorMessage) {
        el.call('openNotification', {
          title: 'Error message',
          message: changes.errorMessage,
          type: 'error'
        })
      }
    },
};